import { disclaimerStore } from '@store/disclaimer-store';
import { sharedStore } from '../../store/sharedStore';
import { Disclaimer } from '../shared/types';

export const formatNumberIN = (amount: number) => {
  if (amount == null || isNaN(amount)) return '';
  return new Intl.NumberFormat('en-IN').format(amount);
};

// export const isSameDomain = (url: string) => {
//   try {
//     const targetHostname = new URL(url, window.location.href).hostname;
//     const currentHostname = window.location.hostname;

//     // Extract domain parts
//     const getDomain = (hostname: string) => {
//       const parts = hostname.split('.');
//       return parts.slice(-2).join('.'); // returns "reward360.in"
//     };

//     return getDomain(targetHostname) === getDomain(currentHostname);
//   } catch {
//     return false;
//   }
// };

// export function isTargetReward360Domain(url: string): boolean {
//   if (!url) return false;

//   try {
//     const parsedUrl = new URL(url, window.location.href);
//     const hostname = parsedUrl.hostname;

//     // Matches reward360.in or any subdomain of it
//     return hostname === 'reward360.in' || hostname.endsWith('.reward360.in');
//   } catch (err) {
//     console.warn('[isTargetReward360Domain] Invalid URL:', url, err);
//     return false;
//   }
// }

declare global {
  interface Window {
    EMULATE_REWARD360_DOMAIN?: boolean;
  }
}

const emulateReward360 = window.EMULATE_REWARD360_DOMAIN === true;

export const isSameDomain = (url: string): boolean => {
  try {
    const targetHostname = new URL(url, window.location.href).hostname;
    const currentHostname = window.location.hostname;

    const normalizedCurrent = emulateReward360 && currentHostname === 'localhost' ? 'smartbuyuat.reward360.in' : currentHostname;

    const normalizedTarget = emulateReward360 && targetHostname === 'localhost' ? 'smartbuyuat.reward360.in' : targetHostname;

    const getDomain = (hostname: string): string => {
      const parts = hostname.split('.');
      return parts.slice(-2).join('.');
    };

    return getDomain(normalizedTarget) === getDomain(normalizedCurrent);
  } catch {
    return false;
  }
};

export const isTargetReward360Domain = (url: string): boolean => {
  if (!url) return false;

  try {
    const parsedUrl = new URL(url, window.location.href);
    const hostname = parsedUrl.hostname;
    if (emulateReward360 && hostname === 'localhost') return true;
    return hostname === 'reward360.in' || hostname.endsWith('.reward360.in');
  } catch (err) {
    console.warn('[isTargetReward360Domain] Invalid URL:', url, err);
    return false;
  }
};

export function getDisclaimerContent(slug: string, redirectUrl: string): any {
  const data = disclaimerStore.disclaimerData;
  const isR360 = isTargetReward360Domain(redirectUrl);
  if (data?.[slug]?.[0]?.disclaimer) {
    return data[slug][0].disclaimer;
  }

  if ((!isSameDomain(redirectUrl) || isR360) && data['system-default']) {
    return data['system-default'][0]?.disclaimers?.find(({ type }) => type === 'navigate-to-r360');
  }

  return undefined;
}

export function isHdfcDomain(url: string): boolean {
  if (typeof url !== 'string' || typeof URL === 'undefined') return false;

  try {
    const parsedUrl = new URL(url);
    const hostname = parsedUrl.hostname;

    const isLocalhost = hostname === 'localhost' || hostname.startsWith('127.') || hostname === '::1';

    return isLocalhost || hostname === 'hdfcbank.com' || hostname.endsWith('.hdfcbank.com');
  } catch (err) {
    console.warn('Invalid URL in isHdfcDomain:', err);
    return false;
  }
}

type RedirectDisclaimerInput = {
  redirectUrl: string;
  disclaimerSlug?: string;
  openInNewTab?: boolean;
};

type RedirectDisclaimerOutput = {
  showPopup: boolean;
  disclaimerContent?: Disclaimer;
  contentType?: string;
  redirectUrl?: string;
};

export function handleRedirectWithDisclaimerLogic(input: RedirectDisclaimerInput): RedirectDisclaimerOutput {
  const { redirectUrl, disclaimerSlug, openInNewTab } = input;
  if (!redirectUrl) return { showPopup: false };
  const isGoingToReward360 = isTargetReward360Domain(redirectUrl);
  const hasDisclaimer = !!disclaimerSlug;
  const disclaimerContent = getDisclaimerContent(disclaimerSlug, redirectUrl);
  if ((hasDisclaimer || (sharedStore.isMain && isGoingToReward360)) && disclaimerContent) {
    return {
      showPopup: true,
      disclaimerContent,
      contentType: Array.isArray(disclaimerSlug) ? disclaimerSlug[0] : disclaimerSlug,
      redirectUrl
    };
  }
  // No disclaimer to show, can proceed to redirect
  if (openInNewTab) {
    window.open(redirectUrl);
  } else {
    window.location.href = redirectUrl;
  }

  return { showPopup: false };
}

// export const getCardHomePath = (): string => {
//   const selectedCard = pathStore.selectedCard;
//   const activeProgram = pathStore.activeProgram;
//   const cardType = (selectedCard?.cardType || activeProgram || '').trim().toLowerCase();
//   return new URL(allowedCardTypes.includes(cardType) ? `/v2/${cardType}` : '/v2/foryou', redirectDomainUrl).toString();
// };

export function isLocalEnvironment(): boolean {
  if (typeof window === 'undefined') {
    return false; // SSR or non-browser context
  }

  const hostname = window.location.hostname;

  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.startsWith('192.168.') || // local network
    hostname.endsWith('.local') // e.g. dev machine
  );
}
